<template>
  <div>
    <div id="rateListEchartTwo"></div>
  </div>
</template>

<script>
import Echarts from "echarts";
export default {
  name: "rateListChart",
  components: {},
  props: {
    echartsData: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  data() {
    return {
      myChart: {}
    };
  },
  created() {
    // console.log(this.echartsData)
  },
  mounted() {
    let _this = this;
    // window.onresize = function () {
    //   _this.myChart.resize();
    // };
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.loadEchart();
    });
  },
  computed: {},
  watch: {
    echartsData: function(newVal) {
      this.loadEchart();
    }
    // echartsData: {
    //   handler(newVal, oldVal) {
    //     if (this.myChart) {
    //       if (newVal) {
    //         this.loadEchart(newVal)
    //       } else {
    //         this.loadEchart(oldVal)
    //       }
    //     } else {
    //       this.loadEchart()
    //     }
    //   },
    //   deep: true //对象内部属性的监听，关键。
    // }
  },
  methods: {
    loadEchart() {
      let colors = ["#F03037", "#FFBE98", "#4868AF"];
      this.myChart = Echarts.init(document.getElementById("rateListEchartTwo"));
      let option = {
        title: {
          // text: "折线图堆叠",
        },
        tooltip: {
          // trigger: "axis",
        },
        legend: {
          // show: false,
          // itemWidth: 14,
          // itemHeight: 14,
          // icon: 'rect',
          bottom: "bottom",
          textStyle: {
            color: "#B4BBE0"
          },
          data: []
        },
        grid: {
          top: "5%",
          left: "3%",
          right: "12%",
          bottom: "10%",
          containLabel: true
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {},
          // },
        },
        xAxis: {
          type: "value",
          // nameTextStyle: {
          //   color: "#B4BBE0",
          //   fontSize: 14
          // },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false,
            textStyle: {
              color: "#B4BBE0",
              fontSize: "14"
            }
          },
          boundaryGap: false,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#4868AF",
              type: "dash",
              opacity: 0.5,
              fontSize: 14
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#4868AF"],
              width: 1,
              type: "dash",
              opacity: 0.1
            }
          }
        },
        yAxis: {
          type: "category",
          data: ["隐患管理", "登录积分", "账号管理", "日常巡查", "值班上报"],
          nameTextStyle: {
            color: "#B4BBE0",
            fontSize: 16
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#E1E6FF",
              fontSize: "16"
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              // show: false,
              color: "#4868AF",
              type: "dash",
              opacity: 0.5
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: ["#4868AF"],
              width: 1,
              type: "dash",
              opacity: 0.1
            }
          }
        },
        series: [
          {
            data: [],
            type: "bar",
            barWidth: 10,
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(220, 220, 220, 0.09)'
            },
            roundCap: true,
            itemStyle: {
              // width: 2.5,
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 6,
              normal: {
                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                color: function(params) {
                  var colorList = [
                    ["rgba(27, 208, 219, 0.1)","#1BD0DB"],
                    ["rgba(87, 194, 94, 0.1)","#57C25E"],
                    ["rgba(40, 126, 255, 0.1)","#287EFF"],
                    ["rgba(255, 116, 40, 0.1)","#ff7428"],
                    ["rgba(27, 208, 219, 0.1)","#4D94DE"],
                  ];
                  let colorItem = colorList[params.dataIndex];
                  return new Echarts.graphic.LinearGradient(1,0,0,0,[
                    {
                      offset:1,
                      color: colorItem[0]
                    },
                    {
                      offset:0,
                      color: colorItem[1]
                    }
                  ],false);
                },
                label: {
                  show: true, //开启显示
                  position: "right", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#B3BEF4",
                    fontSize: 16
                  }
                }
              }
            }
          }
        ],
        color: colors
      };
      let seriesDate = [];
      seriesDate.push(this.echartsData.troubleIntergral || 0);
      seriesDate.push(this.echartsData.loginIntergral || 0);
      seriesDate.push(this.echartsData.userinfoIntergral || 0);
      seriesDate.push(this.echartsData.patrolIntergral || 0);
      seriesDate.push(this.echartsData.dutyReportIntergral || 0);
      option.series[0].data = seriesDate;
      this.myChart.setOption(option);
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
#rateListEchartTwo {
  height: 100%;
  margin-left: 20px;
}
</style>
